import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';
import { projectConfigState } from 'recoil/Academy/projectConfigState';
import { useCurrentUser } from 'src/app.hooks/useCurrentUser';
import { useExamLikeHandler } from 'src/app.hooks/useExamLikeHandler';
import ExamApi from 'lib/api/exam';
import { TExamsInfo } from 'app.type/examsInfo';
import FavoriteIconSvg from 'app.feature/academy/component/icon/heart-icon-regular.svg';
import FavoriteIconSolidSvg from 'app.feature/academy/component/icon/heart-icon-solid.svg';
import CbtBuyButton from './CbtBuyButton';

const CbtButtonGroup = ({ examIdx }: { examIdx: number }) => {
  const router = useRouter();
  const { user } = useCurrentUser();
  const { handleLoginRedirect, handleLikeButtonClick } = useRecoilValue(projectConfigState);

  const queryKey = [`/apiV2/exams/${examIdx}`];

  const {
    data: examInfo,
    isError,
    isLoading,
  } = useQuery<TExamsInfo>({
    queryKey,
    queryFn: () => ExamApi.getExamInfo(examIdx),
  });

  const { handleLikeExam } = useExamLikeHandler(queryKey, (oldData, viewerHasLiked, examIdx) => {
    return {
      ...oldData,
      likeCount: (oldData?.likeCount || 0) + (viewerHasLiked ? -1 : 1),
      viewerHasLiked: !viewerHasLiked,
    };
  });

  const onLikeButtonClick = async () => {
    if (!user) {
      router.push(handleLoginRedirect(window.location.href));
      return;
    }

    if (examInfo?.viewerHasLiked === undefined) {
      return;
    }

    await handleLikeExam(examIdx, examInfo.viewerHasLiked);

    if (handleLikeButtonClick) {
      handleLikeButtonClick(examIdx);
    }
  };

  if (isLoading || isError || !examInfo) return null;

  return (
    <StyledWrapper>
      <button onClick={onLikeButtonClick}>
        {examInfo.viewerHasLiked ? <FavoriteIconSolidSvg /> : <FavoriteIconSvg />} 나의 관심시험
        추가(
        {Number(examInfo.likeCount).toLocaleString() ?? 0})
      </button>
      <CbtBuyButton examIdx={examIdx} />
      {/* <button onClick={onClickModeOption}>랜덤 모의고사 풀기</button> */}
    </StyledWrapper>
  );
};

export default CbtButtonGroup;

const StyledWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 20px;
  margin-top: 44px;

  button,
  a {
    min-width: 271px;
    font-size: 16px;
    padding: 14px 76px;
    background-color: #fff;
    color: #333;
    border: 1px solid #ccc;
    border-radius: 8px;
    > svg {
      vertical-align: middle;
      margin-top: -3px;
    }
  }
`;
